import React, {Component} from 'react';
import './Button.css';

class Button extends Component {
	render() {
		return (
			<button
				className={`Button ${this.props.className || ''} ${this.props.disabled ? 'disabled' : ''}`}
				onClick={this.props.onClick}
				style={{
					fontSize: this.props.size ? `var(--${this.props.size})` : undefined,
					backgroundColor: this.props.theme ? `var(--${this.props.theme})` : undefined
				}}
				disabled={this.props.disabled}
			>
				{this.props.children}
			</button>
		);
	}
}

export default Button;


// WEBPACK FOOTER //
// ./src/widgets/Button.js